import { Component } from '@angular/core';
import { NavController, LoadingController, NavParams, AlertController, ModalController, ToastController } from 'ionic-angular';
import { SelectPage } from '../';
import { User, Master, Subscriber } from '@providers/index';

@Component({
  selector: 'page-list-subscribers',
  templateUrl: 'page.html'
})
export class ListSubscribersPage {

  akses:any={};

  user:any={};
  params:any={
    notification_code : 'new_project_note',
    reference_id      : '',
    id                : '',
    user_id           : '',
    created_by        : '',
    updated_by        : ''
  };
  list:any=[];
  employee = {
    user_id :'',
    name    :''
  };
  project_id:0;
  subscribe_status:boolean;

  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public userApi: User,
    public subsApi: Subscriber,
    public toastCtrl:ToastController,
    public loadingCtrl: LoadingController,
    public modalCtrl : ModalController,
    public navParams: NavParams,
    public alertCtrl: AlertController
    ) {
    this.user = this.userApi.data;
    this.akses= this.userApi.akses;
    console.log(this.akses);

    this.project_id = this.navParams.get('project_id');

    this.params.reference_id = this.project_id;
    
  }

  ionViewDidEnter(){
    this.getList();
  }

  doRefresh(refresher){
    refresher.complete();
    this.getList();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
  
  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    
    this.getSubscribeStatus();

    let params: any =this.params; 
        this.params.id                = '' ;
        this.params.user_id           = '' ;
        this.params.created_by        = '' ;
        this.params.updated_by        = '' ;
    this.subsApi.getTenderSubscribers(params).subscribe((resp:any) => {
      if (resp.data!=''){
        this.list = resp.data;
        loading.dismiss();
      }else{
        this.presentToast("Project ini belum memiliki subscribers");
        loading.dismiss();
      }
    }, (err) => {
      loading.dismiss();
    });
  }

  addSubscriber(){
    this.navCtrl.push(SelectPage, { 
      select_mod : 1,
      project_id:this.project_id 
    });
  }

  deleteSubs(id, user_id){
    let params     = this.params;
        params.id      = id;
        params.user_id = user_id;
        params.updated_by = this.user.user_id;

      this.subsApi.addSubscriber(params).subscribe((resp:any) => {      
        this.getList();
      });
  }

  changeSubscribeStatus(){
    console.log("is User Susbscribe = ", this.subscribe_status);

      let params = this.params;
          params.user_id    = this.user.user_id;
          params.created_by = this.user.user_id;
    
    if(this.subscribe_status==true){
      this.subsApi.addSubscriber(params).subscribe((resp:any) => {      
      this.getList();
      });
    }else{
      let params = this.params;
          params.id          = 1;
          params.user_id     = this.user.user_id;
          params.updated_by  = this.user.user_id;     

      this.subsApi.addSubscriber(params).subscribe((resp:any) => {      
        this.getList();
      });
    }
  }

  getSubscribeStatus(){
    let params = this.params;
        params.user_id = this.user.user_id

    this.subsApi.getSubscribeStatus(params).subscribe((resp:any) => {
      if (resp.data!=''){
        this.subscribe_status=true;
      }else{
        this.subscribe_status=false;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/list_subscribers/page.ts